export default __webpack_public_path__ + "static/media/397.6bd10f9f.png";